var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899827 9.90008H1.79985V16.2C1.79985 17.1927 2.60716 18 3.59988 18H14.4001C15.3928 18 16.2002 17.1927 16.2002 16.2V9.90008H17.1002C17.2782 9.90004 17.4521 9.84724 17.6001 9.74834C17.7481 9.64945 17.8634 9.5089 17.9315 9.34448C17.9996 9.18005 18.0174 8.99912 17.9827 8.82456C17.948 8.65001 17.8623 8.48966 17.7365 8.3638L9.63631 0.263878C9.5528 0.180228 9.45362 0.113865 9.34443 0.0685854C9.23525 0.0233062 9.1182 0 9 0C8.8818 0 8.76476 0.0233062 8.65557 0.0685854C8.54638 0.113865 8.4472 0.180228 8.36369 0.263878L0.263514 8.3638C0.137683 8.48966 0.051995 8.65001 0.0172835 8.82456C-0.017428 8.99912 0.00039506 9.18005 0.0684996 9.34448C0.136604 9.5089 0.251932 9.64945 0.399904 9.74834C0.547876 9.84724 0.721848 9.90004 0.899827 9.90008ZM7.19996 16.2V11.7001H10.8V16.2H7.19996ZM9 2.17276L14.4001 7.5727V11.7001L14.401 16.2H12.6001V11.7001C12.6001 10.7074 11.7928 9.90008 10.8 9.90008H7.19996C6.20724 9.90008 5.39992 10.7074 5.39992 11.7001V16.2H3.59988V7.5727L9 2.17276Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.e0200ea859034ed6a4936d062537a3b2.svg";
export { ForwardRef as ReactComponent };